import { api } from "../../utils/api";

export const patchEnterprise = async (data) => {
  try {
    const response = await api.patch(`enterprise/linkTeam/${data.id}`, data.data);
    // console.log(response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};
